module.exports = __webpack_public_path__ + "img/jyServiceItem10.b11cbbf1.png";